import { EmptyBookingPartner } from '~/components/booking-review/booking-partner';
import { AppointmentInformation } from '../components/appointment-information';

export const config = {
  BookingInformation: {
    appointmentInformation: AppointmentInformation,
  },
  BookingReview: {
    BookingPartner: EmptyBookingPartner,
    icsEvent: {
      isServiceNameIncludedToAppointmentTypeName: true,
    },
  },
};
